import { STATES_LIST } from "@common/states";
import { CodeCombobox, type CodeComboboxProps } from "./CodeCombobox";

const STATE_ABBREVIATIONS = STATES_LIST.map((state) => state.abbreviation);

const stateName = (abbreviation: string) =>
    STATES_LIST.find((state) => state.abbreviation === abbreviation)?.name ??
    abbreviation;

/** Searchable US state picker; `value` is the state abbreviation or `null`. */
export const StateSelect = ({
    buttonSize = "md",
    ...props
}: CodeComboboxProps) => (
    <CodeCombobox
        {...props}
        buttonSize={buttonSize}
        codes={STATE_ABBREVIATIONS}
        codeLabel={stateName}
        placeholder="Select state..."
        searchPlaceholder="Search states..."
        emptyText="No matching states"
    />
);
